<div class="container" class="w-100" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <mat-form-field [fxFlex]="selectedHome ? '0 1 calc(50% - 10px)' : '100%'" fxFlex.lt-sm="100%">
    <mat-label>Home</mat-label>
    <input type="text" matInput [formControl]="homeControl" [matAutocomplete]="homeAuto">
    <mat-autocomplete #homeAuto="matAutocomplete" [displayWith]="displayHome">
      <mat-option *ngFor="let home of filteredHomes | async" [value]="home">
        <!-- {{ home.name }} -->
        <div [innerHtml]="home.name | encodeHtml | highlight: homeControl.value"></div>
      </mat-option>
    </mat-autocomplete>
    <button *ngIf="homeControl?.value?.id" color="primary" matSuffix mat-icon-button matTooltip="browse similar homes" (click)="browse(homeControl?.value?.id)">
      <mat-icon>search</mat-icon>
    </button>
    <button *ngIf="homeControl?.value" matSuffix mat-icon-button color="basic" matTooltip="Clear home" (click)="clearHome()">
      <mat-icon>clear</mat-icon>
    </button>
    <mat-error *ngIf="homeControl.hasError('requireMatch')">
      Select a valid home
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="selectedHome" fxFlex="0 1 calc(50% - 10px)" fxFlex.lt-sm="100%">
    <mat-label>Master File <small matTooltip="{{masterIfcFiles.length}} Master File(s) available">({{masterIfcFiles.length}})</small></mat-label>
    <input type="text" matInput [formControl]="masterFileControl" [matAutocomplete]="masterAuto">
    <mat-autocomplete #masterAuto="matAutocomplete" [displayWith]="displayIfcFile">
      <mat-option *ngFor="let ifcFile of masterIfcFiles" [value]="ifcFile">{{ifcFile.name}}</mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="masterFileControl.hasError('requireMatch')">
      Select a valid master file
    </mat-error>
  </mat-form-field>
  
  <div *ngIf="selectedIfcFiles?.length > 0" class="m-b-20" fxFlex="100">
    <mat-chip-list #optionChipList>
      <mat-chip color="accent" *ngFor="let option of selectedIfcFiles">
        <span>{{ option.name }}</span>
        <!-- <button matChipRemove (click)="removeOption(option)">
          <mat-icon>clear</mat-icon>
        </button> -->
      </mat-chip>
    </mat-chip-list>
  </div>
  <mat-form-field fxFlex="0 1 calc(100% - 10px)" *ngIf="selectedHome && optionIfcFiles?.length > 0">
    <mat-label>Options <small matTooltip="{{optionIfcFiles.length}} Option(s) available">({{optionIfcFiles.length}})</small></mat-label>
    <mat-select multiple [(value)]="selectedIfcFiles">
      <mat-option *ngFor="let ifcFile of optionIfcFiles" [value]="ifcFile">{{ ifcFile.name }}</mat-option>
    </mat-select>
    <button *ngIf="selectedIfcFiles?.length > 0" matSuffix mat-icon-button color="basic" matTooltip="Clear options" (click)="clearOptions()">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>
</div>
